angular.module('gym.calendar').factory('AppointmentTypeCategories', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('appointment_type_categories');
}]);
